export default ["en","fr","de"];